export var TypeActionLoca;
(function (TypeActionLoca) {
    TypeActionLoca["Change"] = "Language > Change";
})(TypeActionLoca || (TypeActionLoca = {}));
export var actionLocaChange = function (lang) { return ({
    lang: lang,
    type: TypeActionLoca.Change,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/loca/actionLoca.ts
// module id = 850
// module chunks = 3